module.exports = __webpack_public_path__ + "static/media/owner-no-active.4a51571d.png";